var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "cui-example cui-example-vertical-spacing"
  }, [_c('b-card', {
    staticClass: "mb-4",
    attrs: {
      "header": "".concat(_vm.$t('reports'), " / ").concat(_vm.$t('report_requests')),
      "header-tag": "h6"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 mb-1"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.$t('files_will_delete_after_a_week')))]), _vm._v(" "), _c('b-btn', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.getReportRequests
    }
  }, [_c('i', {
    staticClass: "fas fa-sync"
  }), _vm._v(" " + _vm._s(_vm.$t('refresh')) + "\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('vue-good-table', {
    ref: "GoodTable",
    attrs: {
      "styleClass": "vgt-table striped",
      "mode": 'remote',
      "compactMode": "",
      "row-style-class": "table-text",
      "max-height": '500',
      "columns": _vm.columns,
      "rows": _vm.tableData,
      "totalRows": _vm.totalRecords,
      "isLoading": _vm.isTableLoading,
      "sort-options": {
        enabled: true
      },
      "pagination-options": {
        enabled: true,
        mode: 'pages',
        // Per Page
        perPage: 10,
        perPageDropdown: [5, 10, 30, 50],
        dropdownAllowAll: false,
        // Translation
        nextLabel: _vm.$t('next'),
        prevLabel: _vm.$t('prev'),
        rowsPerPageLabel: _vm.$t('rows_per_page'),
        ofLabel: _vm.$t('of'),
        pageLabel: _vm.$t('page'),
        // for 'pages' mode
        allLabel: _vm.$t('all')
      }
    },
    on: {
      "update:isLoading": function updateIsLoading($event) {
        _vm.isTableLoading = $event;
      },
      "update:is-loading": function updateIsLoading($event) {
        _vm.isTableLoading = $event;
      },
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange
    },
    scopedSlots: _vm._u([{
      key: "table-column",
      fn: function fn(props) {
        return [_c('span', {
          staticClass: "table-text"
        }, [_vm._v("\n                " + _vm._s(props.column.label) + "\n              ")])];
      }
    }, {
      key: "table-row",
      fn: function fn(props) {
        return [props.column.field === 'status' ? _c('span', {
          staticClass: "table-text"
        }, [_c('span', {
          staticClass: "p-2",
          class: _vm.statusColors[props.row.status.toString()]
        }, [_vm._v(_vm._s(props.row.status_display))])]) : props.column.field === 'file' ? _c('span', {
          staticClass: "table-text"
        }, [props.row.status === 2 && props.row.file !== null ? _c('a', {
          staticClass: "btn btn-sm btn-success",
          attrs: {
            "href": props.row.file,
            "target": "_blank",
            "download": ""
          }
        }, [_c('i', {
          staticClass: "fas fa-download mr-1"
        }), _vm._v(" " + _vm._s(_vm.$t('download')) + "\n                ")]) : props.row.status === 3 ? _c('b-btn', {
          attrs: {
            "size": "sm",
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              return _vm.createReportAgain(props.row.id);
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-history mr-1"
        }), _vm._v(" " + _vm._s(_vm.$t('create_report_again')) + "\n                ")]) : _vm._e()], 1) : _c('span', {
          staticClass: "table-text"
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n              ")])];
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "loadingContent"
    },
    slot: "loadingContent"
  }, [_c('span', {
    staticClass: "badge badge-info p-2"
  }, [_vm._v(_vm._s(_vm.$t('loading')))])]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n              " + _vm._s(_vm.$t("no_records_found")) + "\n            ")]), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "footer-bg",
    attrs: {
      "slot": "table-actions-bottom"
    },
    slot: "table-actions-bottom"
  }, [_vm.totalRecords > 0 ? _c('span', {
    staticClass: "ml-2"
  }, [_vm._v("\n                " + _vm._s('Toplam Kayıt Sayısı : ' + _vm.totalRecords) + "\n              ")]) : _vm._e()])])], 1)])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }